export default {
  en: {
    valueText: '{{label}}: {{value}} of {{max}}',
  },
  ru: {
    valueText: '{{label}}: {{value}} из {{max}}',
  },
  de: {
    valueText: '{{label}}: {{value}} von {{max}}',
  },
  pt: {
    valueText: '{{label}}: {{value}} de {{max}}',
  },
  fr: {
    valueText: '{{label}} : {{value}} sur {{max}}',
  },
  es: {
    valueText: '{{label}}: {{value}} de {{max}}',
  },
};
